import axios from "axios";
import { useSelector } from "react-redux";
import { State } from "@store";
import { GoogleUser } from "@models";
import { useCallback } from "react";

declare const gapi: any;

const useGoogleApi = () => {
  const user = useSelector((state: State) => state.user);
  const lookUpDirectory = useCallback(
    (email: string): Promise<GoogleUser[]> => {
      return new Promise<GoogleUser[]>((resolve, reject) => {
        axios
          .get("https://www.googleapis.com/admin/directory/v1/users", {
            headers: {
              Authorization: `Bearer ${user?.access_token}`,
            },
            params: {
              customer: "my_customer",
              maxResults: 10,
              orderBy: "email",
              viewType: "domain_public",
              query: `email:${email}*`,
            },
          })
          .then((response) => {
            // const users = response.data.users?.filter(
            //   (gUser: GoogleUser) => gUser.primaryEmail !== user?.email
            // );
            resolve(!!response.data.users ? response.data.users : []);
          })
          .catch((err) => reject(err));
      });
    },
    [user]
  );

  return { lookUpDirectory };
};

export { useGoogleApi as useUserApi };
